module.exports = __webpack_public_path__ + "static/img/headset.cddd72d2.svg";